{
  "title": "Real Estate Tracker",
  "subtitle": "Connectez-vous pour continuer",
  "username": "Nom d'utilisateur",
  "password": "Mot de passe",
  "rememberMe": "Se souvenir de moi pendant 30 jours",
  "signIn": "Se connecter",
  "signingIn": "Connexion en cours...",
  "contactAdmin": "Contactez votre administrateur pour obtenir un accès",
  "validationError": "Le nom d'utilisateur et le mot de passe sont requis",
  "loginFailed": "Échec de la connexion",
  "loginError": "Une erreur s'est produite lors de la connexion",
  "logoutFailed": "Échec de la déconnexion",
  "profileUpdateFailed": "Échec de la mise à jour du profil",
  "passwordChangeFailed": "Échec du changement de mot de passe",
  "languageSaveFailed": "Échec de l'enregistrement de la préférence de langue",
  "sessionExpired": "Session expirée - veuillez vous reconnecter"
}
